import React from 'react';
import './NavigationBar.css';
import { Navbar } from 'react-bootstrap';
import { Nav } from 'react-bootstrap';
import { connect } from 'react-redux';
import { toggleForm } from '../Redux/actions';

class NavigationBar extends React.Component {
  state = {
    showTranslator: 'none'
  }

  showTranslator = () => {
    this.state.showTranslator === 'none'
    ? this.setState({ showTranslator: 'inline' })
    : this.setState({ showTranslator: 'none' })
  }

  render() {
    return (
      <div id="navigationBar">
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
          <Navbar.Brand href="https://michael-digi.github.io/covidnyc/" id="brand">NYC-COVID</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="ml-auto" id="navLinks">
              <Nav.Link href="https://www.cdc.gov/coronavirus/2019-ncov/index.html" className="navLink">CDC Guidelines</Nav.Link>
                <Nav.Link href="https://www1.nyc.gov/site/doh/services/texting.page" className="navLink">Get Updates to Your Phone</Nav.Link>
                <Nav.Link className="navLink" onClick={() => this.props.toggleForm()}>Contribute</Nav.Link>
                <Nav.Link className="navLink" onClick={() => this.showTranslator()}>Translate This Page</Nav.Link>
                { <div style={{display: this.state.showTranslator}} id="google_translate_element"></div> }
              </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    )
  }
}

const dispatch = {
  toggleForm
}

export default connect(null, dispatch)(NavigationBar);